import {
  Datagrid,
  DateField,
  DateInput,
  List,
  NumberField,
  required,
  SelectInput
} from 'react-admin'
import { Box, IconButton } from '@mui/material'
import SnapshotButton from '../components/SnapshotButton'
import BulkSnapshotButton from '../components/BulkSnapshotButton'
import BulkDownloadCsv from '../components/BulkDownloadCsv'
import DownloadCsvButton from '../components/DownloadCsvButton'
import PhysicalOrdersActionButtons from '../components/PhysicalOrdersActionButtons'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import BatchSnapshotInfo from '../components/BatchSnapshotInfo'
import { useState } from 'react'

const filters = [
  <DateInput
    key="start"
    label="Start Date"
    source="startAt"
    data-testid="start-input"
    alwaysOn
  />,
  <DateInput
    key="end"
    label="End Date"
    source="endAt"
    data-testid="end-input"
    alwaysOn
  />,
  <SelectInput
    key="view"
    label="View"
    source="orderView"
    validate={required()}
    value="open"
    data-testid="order-view-input"
    choices={[
      { id: 'opened', name: 'Open Orders' },
      { id: 'all', name: 'All Orders' },
      { id: 'late', name: 'Late Orders' },
      { id: 'refunded', name: 'Refunded Orders' }
    ]}
    alwaysOn
  />
]

const BulkActionButtons = () => (
  <>
    <BulkDownloadCsv />
    <BulkSnapshotButton />
  </>
)

const SnapshotInfo = ({ onClick }: { onClick: () => void }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    <IconButton title="Batch Snapshot Info" onClick={onClick}>
      <InfoIcon />
    </IconButton>
  </Box>
)

const PhysicalOrdersList = () => {
  const [openSnapshotInfo, setOpenSnapshotInfo] = useState(false)

  return (
    <Box>
      <List
        filters={filters}
        filterDefaultValues={{ orderView: 'opened' }}
        actions={<PhysicalOrdersActionButtons />}
      >
        <Datagrid bulkActionButtons={<BulkActionButtons />}>
          <DateField label="Batch Date" source="date" sortable={false} />
          <NumberField source="open" sortable={false} />
          <NumberField source="late" sortable={false} />
          <NumberField source="shipped" sortable={false} />
          <NumberField source="refunds" sortable={false} />
          <NumberField source="total" sortable={false} />
          <DateField
            label="Last Downloaded At (PST)"
            source="lastDownloadedAt"
            options={{
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric'
            }}
            sortable={false}
          />
          <SnapshotButton
            label={<SnapshotInfo onClick={() => setOpenSnapshotInfo(true)} />}
          />
          <DownloadCsvButton />
        </Datagrid>
      </List>
      <BatchSnapshotInfo
        open={openSnapshotInfo}
        onClose={() => setOpenSnapshotInfo(false)}
      />
    </Box>
  )
}

export default PhysicalOrdersList
